import '../../Assets/Styles/Header.css';
import './Faq.css';
import React from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useMediaQuery } from 'react-responsive'

import { Button } from 'primereact/button'; 
import { Panel } from 'primereact/panel';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Dropdown } from 'primereact/dropdown';

// Import template images
// import logo from '../../Assets/Images/logoEstacaoHeader.svg'; 
import logo from '../../Assets/Images/logoEstacaoHeader.png'; 
import iconProfile from '../../Assets/Images/iconProfile.svg'; 
import iconRoute from '../../Assets/Images/iconRoute.svg';
import iconCategory from '../../Assets/Images/iconCategory.svg';  
import edoLogoOnly from '../../Assets/Images/edoLogoOnly.svg'; 

// Load Actions
import * as AppActions from '../../Store/Actions/App';


const stripHtml = (html) => {
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || div.innerText || "";
};

// UpdateService dialog component
const FaqView = (props) => {

// set vars from props
const {
    whiteBackground = false,
    mTop = "3rem",
    type = "partner",
} = props;		

const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

const [selectedButton, setSelectedbutton] = React.useState(null);
const [panelVisibility, setPanelVisibility] = React.useState({});

const [groupedByCategory, setGroupedByCategory] = React.useState({});
const [loading, setLoading] = React.useState(true);
const [categories, setCategories] = React.useState({});

const [dropdownOptions,setDropdownOption] = React.useState([]);
const [activeIndex,setActiveIndex] = React.useState(0);

//console.log('dropdownOptions |---------------> '+JSON.stringify(dropdownOptions,null,2));

const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1023px)' });

  React.useEffect(() => {
    fetchFaq();
  }, []);

  const fetchFaq = async () => {
    try {

      const [faqRes, catRes] = await Promise.all([
        fetch(`https://backendcms.estacaodoolho.com.br/wp-json/wp/v2/${type == 'partner' ? 'pergunta-frequente' : 'pergunta-frequente-p'}?_embed&status=publish&per_page=100`),
        fetch(`https://backendcms.estacaodoolho.com.br/wp-json/wp/v2/${type == 'partner' ? 'categoria-faq-x' : 'categoria-faq-p'}`)
      ]);

      const faqJson = await faqRes.json();
      const catJson = await catRes.json();

      const catMap = {};
      const catOptions = [];
      catJson.forEach(cat => {
        catMap[cat.id] = cat.name;
        catOptions.push({label:cat.name,value:cat.id});
      });
      setCategories(catMap);
      setDropdownOption(catOptions);
      setActiveIndex(catOptions[0].value);

      const grouped = {};
      faqJson.forEach(item => {


        const catId = type == 'partner' ? item["categoria-faq-x"]?.[0] : item["categoria-faq-p"]?.[0];
        
        const catName = catMap[catId] || 'Outros';

        if (!grouped[catName]) grouped[catName] = [];

        grouped[catName].push({
          id: item.id,
          title: item.title?.rendered || 'Sem título',
          content: stripHtml(item.content?.rendered || 'Sem conteúdo')
        });
      });

      setGroupedByCategory(grouped);
      setSelectedbutton(Object.keys(catMap)[0]);
    } catch (err) {
      console.error('Erro ao buscar FAQ:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleTabChange = async (e) => {
    
    setActiveIndex(e.index);
    setSelectedbutton(e.index);

};

	return (
	<>

            <div className={isMobile ? "flex-column flex-1_3 dFlex justify-start align-items-stretch w100" : "flex-row flex-1_3 dFlex justify-start align-items-stretch w100"} style={{position:"relative",gap:"16px",marginLeft:"0px",paddingTop:"2.5rem",marginTop:mTop}}> 
            <div style={{position:"absolute",top:0,left:0}}><img src={edoLogoOnly} style={{width:"2.5rem",height:"auto",aspectRatio:"40/27.20"}} className="noSelect" /></div>
                
                <div style={{flexBasis:isMobile ? "0" : "20.7rem",padding:"5px",gap:"16px"}} className="flex-column justify-start align-items-stretch">

                    <div className={whiteBackground ? "faqTitle rainbowColor" : "faqTitle"}>
                        <h2>Ficou com dúvida?</h2>
                        <h3>A gente responde</h3>
                    </div>

                    {/* Renderizando as categorias */}
                    {!isMobile && 
                    <>
                        {Object.entries(categories).map(([catId, catName]) => (
                        <div
                            key={catId}
                            className={selectedButton == catId ? "faqButton selected" : "faqButton"}
                            onClick={() => setSelectedbutton(catId)}
                        >
                            <div className={selectedButton == catId ? "faqButtonIcon selected" : "faqButtonIcon"}>
                            <img src={iconCategory} className="nopSelect" alt="" />
                            </div>
                            <div className={selectedButton == catId ? "faqButtonTitle selected" : "faqButtonTitle"}>
                            {catName}
                            </div>
                        </div>
                        ))}
                    </>
                    }

                    {isMobile &&
                    <>
                        <div style={{ width: '100%'}}>
                            <Dropdown
                                value={activeIndex}
                                options={dropdownOptions}
                                onChange={(e) => handleTabChange({ index: e.value })}
                                placeholder="Selecione uma opção"
                                style={{ width: '100%' }}
                                className="faqDropdownSelector"
                            />
                        </div>
                    </>
                    }

                    {/*<div className={selectedButton == 1 ? "faqButton selected" : "faqButton"} onClick={()=>setSelectedbutton(1)}>
                        <div className={selectedButton == 1 ? "faqButtonIcon selected" : "faqButtonIcon"}>
                           <img src={iconCategory} className='nopSelect' />  
                        </div>
                        <div className={selectedButton == 1 ? "faqButtonTitle selected" : "faqButtonTitle"}>Dúvidas sobre parceria</div>
                    </div>

                    <div className={selectedButton == 2 ? "faqButton selected" : "faqButton"} onClick={()=>setSelectedbutton(2)}>
                        <div className={selectedButton == 2 ? "faqButtonIcon selected" : "faqButtonIcon"}>
                            <img src={iconCategory} className='nopSelect' />                    
                        </div>
                        <div className={selectedButton == 2 ? "faqButtonTitle selected" : "faqButtonTitle"}>Dúvidas mais acessadas</div>
                    </div>

                    <div className={selectedButton == 3 ? "faqButton selected" : "faqButton"} onClick={()=>setSelectedbutton(3)}>
                        <div className={selectedButton == 3 ? "faqButtonIcon selected" : "faqButtonIcon"}>
                           <img src={iconCategory} className='nopSelect' />                      
                        </div>
                        <div className={selectedButton == 3 ? "faqButtonTitle selected" : "faqButtonTitle"}>Dúvidas sobre clínicas, médicos e óticas</div>
                    </div>*/}              


                </div> 
                <div style={{flexBasis:"38.2rem",padding:"5px",marginRight:isMobile ? "0" : "30px",display:"flex",alignItems:"stretch"}}>
                    
                     <div className="wraper__contactUsQuestion w100" style={{backgroundColor:"transparent",height:"auto",borderRadius:"24px"}}>

                    {loading ? (
                        <div className="w100 flex-row justify-center align-items-center" style={{ minHeight: '10rem' }}>
                        <ProgressSpinner />
                        </div>
                    ) : (
                        Object.entries(groupedByCategory).map(([category, questions]) => (
                        String(categories[selectedButton]) === category && (
                            <div key={category} className="faqCategoryBlock w100 flex-column" style={{gap:"1rem"}}>
                            {questions.map(q => (
                                <Panel
                                key={q.id}
                                className="contactUsQuestion"
                                /*header={q.title}*/
                                header={
                                    <div onClick={() => setPanelVisibility(prev => ({ ...prev, [q.id]: !prev[q.id] }))} style={{ cursor: 'pointer' }}>
                                        {q.title}
                                    </div>
                                }                                
                                toggleable
                                collapsed={!panelVisibility[q.id]}
                                onToggle={(e) => setPanelVisibility(prev => ({ ...prev, [q.id]: !prev[q.id] }))}
                                >
                                    <p className="m0" style={{ margin: 0 }}>{q.content}</p>
                                </Panel>
                            ))}
                            </div>
                        )
                        ))
                    )}

{/*}
                        {selectedButton == 1 &&
                        <>

                        <Panel className="contactUsQuestion"  header={
                            <div onClick={() => togglePanel('panel1')} style={{ cursor: 'pointer' }}>
                                Como funciona a triagem de pacientes?
                            </div>
                        } toggleable collapsed={panelVisibility.panel1} onToggle={(e) => setPanelVisibility({ ...panelVisibility, panel1: e.value })}>
                            <p className="m0" style={{margin:0}}>
                               Apenas empresas haiblitadas para comercializar produtos de turismo podem se cadastrar na plataforma. É necessário que a empresa tenha um ou mais CNAEs referentes a área de turismo. Não insista caso sua empresa não se aplique pois o cadastro será reprovado. 
                            </p>
                        </Panel>

                        <Panel className="contactUsQuestion"   header={
                            <div onClick={() => togglePanel('panel2')} style={{ cursor: 'pointer' }}>
                                Quanto tempo demora para receber os leads?
                            </div>
                        } toggleable collapsed={panelVisibility.panel2} onToggle={(e) => setPanelVisibility({ ...panelVisibility, panel2: e.value })}>
                            <p className="m0" style={{margin:0}} >
                               Para prosseguir com o cadastro de sua empresa é necessário que o responsável técnico seja o mesmo do trazido da RFB automaticamente. Adotamos essa medida para evitar cadastro com divergências e acelerar o processo de cadastro. 
                            </p>
                        </Panel>

                        <Panel className="contactUsQuestion"  header={
                            <div onClick={() => togglePanel('panel3')} style={{ cursor: 'pointer' }}>
                                Posso escolher quantos leads quero receber por mês?
                            </div>
                        } toggleable collapsed={panelVisibility.panel3} onToggle={(e) => setPanelVisibility({ ...panelVisibility, panel3: e.value })}>
                            <p className="m0" style={{margin:0}} >
                               A plataforma Dream4 faz a busca dos dados da sua empresa, à partir do CNPJ, diretamente da RFB. Os dados refletem exatamente o que está na base de dados do governo. Caso entende que haja alguma discrepância é possível que tenha feito recentemente e não tenha refletido na base da RFB ainda. Pedimos que nesse caso entre em contato conosco para análise manual. 
                            </p>
                        </Panel>

                        <Panel className="contactUsQuestion"  header={
                            <div onClick={() => togglePanel('panel4')} style={{ cursor: 'pointer' }}>
                               Os pacientes já vêm com exames?
                            </div>
                        } toggleable collapsed={panelVisibility.panel4} onToggle={(e) => setPanelVisibility({ ...panelVisibility, panel4: e.value })}>
                            <p className="m0" style={{margin:0}}>
                               A plataforma Dream4 é integrada com diversos serviços externos que eventualmente podem ter instabilidades. Outra situação que pode ocorrer é probblema em sua internet. Solicitamos que desligue e ligue o seu computador para verificar se o problema não é sua internet. Caso o problema persista, entre em contato conosco. 
                            </p>
                        </Panel>  

                        <Panel className="contactUsQuestion"  header={
                            <div onClick={() => togglePanel('panel5')} style={{ cursor: 'pointer' }}>
                              Qual o diferencial da Estação do Olho para outros modelos?
                            </div>
                        } toggleable collapsed={panelVisibility.panel5} onToggle={(e) => setPanelVisibility({ ...panelVisibility, panel5: e.value })}>
                            <p className="m0" style={{margin:0}}>
                               A plataforma Dream4 é integrada com diversos serviços externos que eventualmente podem ter instabilidades. Outra situação que pode ocorrer é probblema em sua internet. Solicitamos que desligue e ligue o seu computador para verificar se o problema não é sua internet. Caso o problema persista, entre em contato conosco. 
                            </p>
                        </Panel> 

                        <Panel className="contactUsQuestion"  header={
                            <div onClick={() => togglePanel('panel6')} style={{ cursor: 'pointer' }}>
                               O que acontece se uma doença ocular for detectada?
                            </div>
                        } toggleable collapsed={panelVisibility.panel6} onToggle={(e) => setPanelVisibility({ ...panelVisibility, panel6: e.value })}>
                            <p className="m0" style={{margin:0}}>
                               A plataforma Dream4 é integrada com diversos serviços externos que eventualmente podem ter instabilidades. Outra situação que pode ocorrer é probblema em sua internet. Solicitamos que desligue e ligue o seu computador para verificar se o problema não é sua internet. Caso o problema persista, entre em contato conosco. 
                            </p>
                        </Panel>  

                        <Panel className="contactUsQuestion"  header={
                            <div onClick={() => togglePanel('panel7')} style={{ cursor: 'pointer' }}>
                               A estação de triagem é acessível para pessoas com mobilidade reduzida?
                            </div>
                        } toggleable collapsed={panelVisibility.panel7} onToggle={(e) => setPanelVisibility({ ...panelVisibility, panel7: e.value })}>
                            <p className="m0" style={{margin:0}}>
                               A plataforma Dream4 é integrada com diversos serviços externos que eventualmente podem ter instabilidades. Outra situação que pode ocorrer é probblema em sua internet. Solicitamos que desligue e ligue o seu computador para verificar se o problema não é sua internet. Caso o problema persista, entre em contato conosco. 
                            </p>
                        </Panel>  

                        <Panel className="contactUsQuestion"  header={
                            <div onClick={() => togglePanel('panel8')} style={{ cursor: 'pointer' }}>
                               O exame causa alguma dor?
                            </div>
                        } toggleable collapsed={panelVisibility.panel8} onToggle={(e) => setPanelVisibility({ ...panelVisibility, panel8: e.value })}>
                            <p className="m0" style={{margin:0}}>
                               A plataforma Dream4 é integrada com diversos serviços externos que eventualmente podem ter instabilidades. Outra situação que pode ocorrer é probblema em sua internet. Solicitamos que desligue e ligue o seu computador para verificar se o problema não é sua internet. Caso o problema persista, entre em contato conosco. 
                            </p>
                        </Panel>                                                                                                    

                        </>
                        }

                        {selectedButton == 2 &&
                        <>

                        <Panel className="contactUsQuestion"  header={
                            <div onClick={() => togglePanel('panel9')} style={{ cursor: 'pointer' }}>
                               Como funciona o processo de aprovação do meu cadastro?
                            </div>
                        } toggleable collapsed={panelVisibility.panel9} onToggle={(e) => setPanelVisibility({ ...panelVisibility, panel9: e.value })}>
                            <p className="m0" style={{margin:0}}>
                               O processo de análise de seu cadastro é simples. Após preenchimento e envio dos dados de sua agência, levaremos em média 72h para avaliar o seu cadastro, que pode ser aprovado ou reprovado. Para ambos os casos você será notificado via email. Dependendo do motivo da reprovação, você poderá fazer os ajustes e reenviar para análise.
                            </p>
                        </Panel>

                        <Panel className="contactUsQuestion"   header={
                            <div onClick={() => togglePanel('panel10')} style={{ cursor: 'pointer' }}>
                                Quais os motivos comuns de reprovação de um cadastro?
                            </div>
                        } toggleable collapsed={panelVisibility.panel10} onToggle={(e) => setPanelVisibility({ ...panelVisibility, panel10: e.value })}>
                            <p className="m0" style={{margin:0}} >
                              Normalmente um cadastro é reprovado quando tem dados inconsistentes, como por exemplo o responsável da empresa ser informado errado, ou o código CNAE da empresa não permitir atuar na área de turismo. Independente do motivo, você será informado.
                            </p>
                        </Panel>

                        <Panel className="contactUsQuestion"  header={
                            <div onClick={() => togglePanel('panel11')} style={{ cursor: 'pointer' }}>
                                E se a análise de meu cadastro demorar mais do que 72h?
                            </div>
                        } toggleable collapsed={panelVisibility.panel11} onToggle={(e) => setPanelVisibility({ ...panelVisibility, panel11: e.value })}>
                            <p className="m0" style={{margin:0}} >
                               Eventualmente o prazo máximo de análise de seu cadastro pode ser maior. Se por acaso for o seu caso, pedimos que entra em contato via mensagem ou whastapp para analisar o status do mesmo. 
                            </p>
                        </Panel>

                        </>
                        }

                        {selectedButton == 3 &&
                        <>

                        <Panel className="contactUsQuestion"  header={
                            <div onClick={() => togglePanel('panel12')} style={{ cursor: 'pointer' }}>
                                Quais são as formas de pagamento aceitas?
                            </div>
                        } toggleable collapsed={panelVisibility.panel12} onToggle={(e) => setPanelVisibility({ ...panelVisibility, panel12: e.value })}>
                            <p className="m0" style={{margin:0}}>
                               Permitimos a compra de hospedagem utilizando cartão de crédito ou PIX.  Aceitamos parcelamento em até 10x sem juros com parela mínima de R$ 100,00.
                            </p>
                        </Panel>

                        <Panel className="contactUsQuestion"   header={
                            <div onClick={() => togglePanel('panel13')} style={{ cursor: 'pointer' }}>
                               Quem deve ser o titular do cartão de crédito de minha compra?
                            </div>
                        } toggleable collapsed={panelVisibility.panel13} onToggle={(e) => setPanelVisibility({ ...panelVisibility, panel13: e.value })}>
                            <p className="m0" style={{margin:0}} >
                               Por motivo de segurança, o titular do cartão de crédito deve ser a mesma pessoa (nome e CPF) que fez a reserva da hospedagem. 
                            </p>
                        </Panel>

                        <Panel className="contactUsQuestion"  header={
                            <div onClick={() => togglePanel('panel14')} style={{ cursor: 'pointer' }}>
                               É possível cancelar uma compra?
                            </div>
                        } toggleable collapsed={panelVisibility.panel14} onToggle={(e) => setPanelVisibility({ ...panelVisibility, panel14: e.value })}>
                            <p className="m0" style={{margin:0}}>
                               Sim, desde que respeitado os prazos máximos para cancelamento. Caso o cancelamento seja feito após o prazo máximo haverá uma multa. 
                            </p>
                        </Panel>   

                        </>
                        }  
*/}


                    </div>                     

                </div>

            </div>
	</>	
	);
	
}

const mapStateToProps = store => ({
  dialog:store.appReducer.dialog
 });
const mapDispatchToProps = dispatch => bindActionCreators({ ...AppActions }, dispatch);

export default connect(
		mapStateToProps,
		mapDispatchToProps
	)(FaqView);	
